import { apiRequest } from './httpClient';

// Búsquedas reales de Google que traen tráfico al sitio — data real de
// Search Console, no un estimado. Requiere que un admin haya configurado
// settings/integrations.googleSearchConsole (ver docs/estrategia-verticales-y-captacion-2026-09.md).
export const getSearchConsolePerformance = (days = 28) => apiRequest('getSearchConsolePerformance', {
  method: 'GET',
  query: { days },
});

export const getDemandIntelligenceDashboard = (days = 28) => apiRequest('getDemandIntelligenceDashboard', {
  method: 'GET',
  query: { days },
});

export const generateSeoLandingBrief = (opportunity, context = {}) => apiRequest('generateSeoLandingBrief', { method: 'POST', body: { opportunity, ...context } });
export const listSeoLandingBriefs = () => apiRequest('listSeoLandingBriefs', { method: 'GET' });
export const listPublishedMarketingLandings = () => apiRequest('listPublishedMarketingLandings', { method: 'GET' });
export const getSeoLandingBrief = (briefId) => apiRequest('getSeoLandingBrief', { method: 'GET', query: { briefId } });
export const updateSeoLandingBrief = (briefId, brief) => apiRequest('updateSeoLandingBrief', { method: 'POST', body: { briefId, brief } });
export const uploadSeoLandingAsset = (asset) => apiRequest('seoLandingUploadAsset', { method: 'POST', body: { asset } });
export const publishSeoLandingBrief = (briefId) => apiRequest('publishSeoLandingBrief', { method: 'POST', body: { briefId } });

// Público: el visitante de una landing no necesita una sesión de Firebase.
export const getLandingQualificationWizard = (slug) => apiRequest('getLandingQualificationWizard', {
  method: 'GET', query: { slug }, requireAuth: false,
});
export const submitLandingQualificationWizard = ({ slug, contact, answers, attribution }) => apiRequest('submitLandingQualificationWizard', {
  method: 'POST', body: { slug, contact, answers, attribution }, requireAuth: false,
});
// Señales anónimas de landing: no crean contactos ni envían campañas. Sirven
// para que Marketing vea el recorrido en vivo y cruce fuente/campaña/CTA.
export const trackMarketingLiveEvent = (payload) => apiRequest('trackMarketingLiveEvent', {
  method: 'POST', body: payload, requireAuth: false,
});
export const getSeoLeadAttributionReport = (days = 28) => apiRequest('getSeoLeadAttributionReport', {
  method: 'GET', query: { days },
});

// Sugerencias de IA sobre qué palabras priorizar y qué título/descripción usar
// en la portada — no escribe nada, solo sugiere (ver getSeoOpportunities en
// calendar-functions/index.js).
export const getSeoOpportunities = () => apiRequest('getSeoOpportunities', {
  method: 'GET',
});

// Aplica una sugerencia aprobada por un admin al landing real (config/landing).
export const applySeoTitleDescription = (title, description) => apiRequest('applySeoTitleDescription', {
  method: 'POST',
  body: { title, description },
});
